<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.sla"
            sort-by="sla"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="!item.allowDestroy && item.id"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>

// Components.
import Modal from './Modal'

export default {
    components: { Modal },
    data: () => ({
        fields: [
            { key: 'prioridadeNome', label: 'Prioridade', sortable: true },
            { key: 'tempoDeAtendimento', label: 'Tempo de atendimento', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(sla) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o registro?',
                async () => this.data.model.sla.splice(this.data.model.sla.indexOf(sla), 1)
            )
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>